import parseDialogue from "../../util/parseDialogue";

export const SuperphreakQ1Lose = parseDialogue(`
superphreak:q1-lose:100-400

#100 ~~~ ~~~~~ ~~~~ ~~~~~ Hey, are you reading me?
>200 Yeah.

#200 Well, ~ ~~~~~ It happened. Nightfall. Luckily Disarray is a sloppy programmer. I found a hole in his code. ~~~~ ~ ~~~ use to keep the netmap up for a bit longer. I'm not sure ~~~~ ~~~~ I can hold on though.
>300 Got it.

#300 Load up on credits and warez. ~~~ ~~~~ ~~ holding the net up. ~~ ~~~ ~~~~ ~~~ ~~~
>400 Close.
`);
